import React from 'react';

export default props => <img src={require('./White 24.svg')} alt='Logo' {...props}/>
